<template>
    <v-container fluid>
        <v-card class="mb-5">
            <customer-tabs :customer="customer_id"></customer-tabs>

            <v-row class="mt-5 px-3">
                <v-col>
                    <sarala-table
                        :model="model"
                        :query="query"
                        :resourceName="$tc('resources.plan-proposal.name', 1)"
                        :createRoute="{ name: 'plan-proposal.create' }"
                        ref="table"
                    >
                        <template #customer="{ item }">
                            <span class="body-2">{{
                                item.customer.trade_name
                            }}</span>
                        </template>
                        <template #plan_package="{ item }">
                            <span class="body-2">{{
                                item.planPackage.name
                            }}</span>
                        </template>
                    </sarala-table>
                </v-col>
            </v-row>
            <confirm-delete ref="confirmDelete" />
        </v-card>
    </v-container>
</template>

<script>
import PlanProposal from '@/models/PlanProposal'
import SaralaTable from '@/shared/components/SaralaTable'
import CustomerTabs from '@/components/common/CustomerTabs'

export default {
    props: {
        customer_id: {
            required: true,
        },
    },

    components: {
        CustomerTabs,
        SaralaTable,
    },

    computed: {
        model() {
            return new PlanProposal()
        },
    },

    methods: {
        query(model) {
            if (this.customer_id) {
                model.where('customer_id', this.customer_id)
            }
            return model
        },

        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(item.name)
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.plan-proposal.name', 1),
                }),
            )
        },
    },
}
</script>

<style></style>
